import NumberSearch from './NumberSearch';

export default NumberSearch;
